import { useMemo } from 'react';

const useOrderNumberPostfix = (value: number | undefined | null): string => {
  return useMemo(() => {
    if (value === undefined || value === null || isNaN(value) || value === 0) {
      return '';
    }

    const remainderTen = value % 10;
    const remainderHundred = value % 100;

    // Handle exceptions for 11, 12, and 13
    if (remainderHundred >= 11 && remainderHundred <= 13) {
      return `${value}th`;
    }

    switch (remainderTen) {
      case 1:
        return `${value}st`;
      case 2:
        return `${value}nd`;
      case 3:
        return `${value}rd`;
      default:
        return `${value}th`;
    }
  }, [value]);
};
export default useOrderNumberPostfix;
